import { createAction, props } from '@ngrx/store';

import { SessionDataMapped } from '@airtradeit/authentication';

export const SET_SESSION = '[session] Set';

export const setSession = createAction(SET_SESSION, props<{ data: SessionDataMapped }>());
